module.exports = __webpack_public_path__ + "assets/videos/wuhan_zoomin.mp4?v=a28578d7";